import React from "react";
import { OpenRouterModel } from "../../api/openrouterApi";
import { ModelListItem } from "./ModelListItem";
import { Spinner } from "../../utils/Spinner";

type Props = {
  data: OpenRouterModel[] | null;
  loading: boolean;
  error: string | null;
  token: string | null;
  onModelAdded: () => void;
};

export const ModelList: React.FC<Props> = ({
  data,
  loading,
  error,
  token,
  onModelAdded,
}) => {
  if (loading) {
    return (
      <div className="tw-flex tw-justify-center tw-items-center tw-py-12">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="tw-bg-red-50 tw-border tw-border-red-200 tw-rounded-md tw-p-4">
        <p className="tw-text-red-800 tw-text-sm">{error}</p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="tw-text-center tw-py-12">
        <p className="tw-text-gray-500 tw-text-sm">No models found</p>
      </div>
    );
  }

  return (
    <div>
      <div className="tw-mt-6 tw-text-sm tw-text-gray-600">
        Showing {data.length} model{data.length !== 1 ? "s" : ""}
      </div>
      <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-4">
        {data.map((model) => (
          <ModelListItem
            key={model.id}
            model={model}
            token={token}
            onModelAdded={onModelAdded}
          />
        ))}
      </div>
    </div>
  );
};
